import { LeadFormService } from './../../../../services/lead-form.service';
import { CommonModule } from '@angular/common';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Component, OnInit, Inject, ChangeDetectorRef, HostListener, ElementRef } from '@angular/core';
import {  PreQualLeadInfo} from './../../../../interfaces/credit-application-config.interface';
import { IConfig } from './../../../../interfaces/config.interface';
import { isIEorEdge } from './../../../../utils/utils.functions';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DomSanitizer } from '@angular/platform-browser';
import { ChromeVehicleInformation } from 'projects/dt-an-prequalification-lib/src/lib/interfaces/ChromeVehicleInformation.interface';
import { AnalyticsEventService } from '../../../../services/analytics-event.service';
import { ContactStoreComponentLoaded } from '../../../../actions/analytics.action';
import { FormInfoService } from 'projects/dt-an-prequalification-lib/src/lib/services/form-info.service';
import { TealiumService } from 'projects/dt-an-prequalification-lib/src/lib/services/tealium.service';
import { CustomValidator } from 'projects/dt-an-prequalification-lib/src/lib/utils/customValidatorDOB';
import { IValidateLeadResponse, IValidateLeadRequest } from '../../../../interfaces/lead-validation.interface';

@Component({
  selector: 'dt-contact-store',
  templateUrl: './contact-store.component.html',
  styleUrls: ['./contact-store.component.scss'],
  standalone:false
})
export class ContactStoreComponent implements OnInit {
  isFormPristine = true;
  phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  phonePattern = '^[(]{1}[0-9]{3}[)]{1}[ ]{1}[0-9]{3}[-]{1}[0-9]{4}$';
  namePattern = '^[a-zA-Z]+(([\'`\-\s][a-zA-Z])?[a-zA-Z]*)$';
  MIPattern = '^[A-Za-z]*$';
  emailPattern = '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$';
  wordOnlyRegexp = '\\S[\\w\\s-,\\.#&\\(\\)\\+\'"\s]';
  scrubInvalidChars = '[^a-zA-Z0-9\s]';
  onlyLetterNumberAndSpacePattern = /^[a-zA-Z0-9 ]*$/;
  zipCodeMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
  SCData: any;
  win = (window as any);
  preQualForm: UntypedFormGroup;
  formSubmitAttempt = false;
  formSubmitted = false;
  ssnflag = false;
  IE = false;
  isSaving = false;
  showConfirmation: boolean;
  showJackedModal: boolean;
  preQualLeadInfo: PreQualLeadInfo;
  isVinAvailable = false;
  istest = false;
  invalidVin: boolean;
  invalidVinDetails: ChromeVehicleInformation = null;
  disableEmailField = false;
  isTabletView = false;
  isDeepLink: boolean;
  isLoggedIn: boolean;
  src: string;
  subSrc: string;
  isFormStarted = false;
  autonationLogo: any;
  validationId: any;
  private rejectedEmailValidator: ValidatorFn | null = null;
  private rejectedPhoneValidator: ValidatorFn | null = null;
  get Zipcode(): any {
    return this.preQualForm.get('Zipcode');
  }
  public get firstName(): string {
    if (this.config.Sitecore) {
      return this.config.Sitecore.PreQualLeadInfo.firstName || '';
    }
    return '';
  }

  public get isIframe(): boolean {
    return this.config.Sitecore ? this.config.Sitecore.isIframe : null;
  }

  public get middleInitial(): string {
    if (this.config.Sitecore) {
      return this.config.Sitecore.PreQualLeadInfo.middleInitial || '';
    }
    return '';
  }


  public get lastName(): string {
    if (this.config.Sitecore) {
      return this.config.Sitecore.PreQualLeadInfo.lastName || '';
    }
    return '';
  }


  public get email(): string {
    if (this.config.Sitecore) {
      return this.config.Sitecore.PreQualLeadInfo.email || '';
    }
    return '';
  }

  public get phoneNumber(): string {
    if (this.config.Sitecore) {
      return this.PhoneNumberUpdate(this.config.Sitecore.PreQualLeadInfo.phone) || '';
    }
    return '';
  }

  get zipcode(): any {
    if (this.config.Sitecore) {
      return this.config.Sitecore.PreQualLeadInfo.zipcode || '';
    }
    return '';
  }



  PhoneNumberUpdate(phone) {
    if (phone && phone !== undefined && phone !== null) {
      let p = phone.match(/\d/g);
      p = p.join('');
      return '(' + p.substr(0, 3) + ') ' + p.substr(3, 3) + '-' + p.substr(6, 4);
    }
    return '';
  }

  constructor(
    private fb: UntypedFormBuilder,
    @Inject('config') public config: IConfig,
    private cd: ChangeDetectorRef,
    private ngxService: NgxUiLoaderService,
    public sanitizer: DomSanitizer,
    public leadsvc: LeadFormService,
    private analyticsEventService: AnalyticsEventService,
    private formService: FormInfoService,
    private elementRef: ElementRef,
    private tealium: TealiumService
  ) {


  }

  ngOnInit() {
    this.isTabletView = window.innerWidth < 992;
    console.log('test', this.config.Sitecore)

    if (
      this.config &&
      this.config.Sitecore &&
      this.config.Sitecore.ContactStoreLabel
    ) {
      this.SCData = this.config.Sitecore.ContactStoreLabel;
      this.src = this.config.Sitecore.ContactStoreSrc;
      this.subSrc = this.config.Sitecore.ContactStoreSubSrc;
      this.preQualLeadInfo = this.config.Sitecore.PreQualLeadInfo;

      this.isVinAvailable = this.preQualLeadInfo.vin !== '';
      this.invalidVin = this.config.Sitecore.isBuyNowVinInValid || false;
      this.isDeepLink = this.config.Sitecore.PreQualLeadInfo._isDeepLink;
      if (this.invalidVin) {
        this.invalidVinDetails = this.config.Sitecore.ChromeVinDetails || null;
      }
    }
    const inputValue = (<HTMLInputElement>document.getElementById('ANUserId')) ? (<HTMLInputElement>document.getElementById('ANUserId')).value : '';

    if (inputValue) {
      this.isLoggedIn = true;
    }

    this.setupFormData();

    this.IE = isIEorEdge();
    this.setupFormLoadTealium();
    const checkAda = setInterval(() => {
      const x : any =  document.querySelector('#adas-init-access-tool #adas-access-tool-general-button.ada-icon-muted-footer')
      if(x) {
        const applyStyle = () => {
        if(window.innerWidth >= 1024 ) {
          x?.style.setProperty('bottom', '12px', 'important');
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {

          x?.style.setProperty('bottom', '42px', 'important');
        } else if(window.innerWidth < 768 ) {
          x?.style.setProperty('bottom', '74px', 'important');
        }
      }
        applyStyle();
        clearInterval(checkAda);
        window.addEventListener('resize', applyStyle);
      }

    }, 100);
    setTimeout(() => {
      clearInterval(checkAda);
    }, 3000);
  }

  ngAfterViewInit() {
    var image = document.querySelector('.autonation-logo');
    if(image) {
      image.addEventListener('click', this.callLogoClick);
    }
  }

  callLogoClick() {



    // this.formService.reportLogoClick(this.config.Sitecore);
    try {
          let data = JSON.parse(
          document.getElementById(
            'dt-credit-app-state'
          ).innerText
              .replace(new RegExp('&q;', 'g'), '"')
              .replace(new RegExp('&a;', 'g'), '&')
              // tslint:disable-next-line:quotemark
              .replace(new RegExp('&s;', 'g'), "'")
              .replace(new RegExp('&l;', 'g'), '<')
              .replace(new RegExp('&g;', 'g'), '>')
          );
          const isConfirm = (window as any).isConfirm;
          const leadFormData: any = {};
          leadFormData.category_l1 = 'Contact';
          leadFormData.category_l2 = 'OEM Referral';
          leadFormData.category_l3 = isConfirm ? 'Confirmation' : '(not set)';
          leadFormData.category_l4 = '(not set)';
          leadFormData.event_value = 1;
          leadFormData.event_type	= "InternalActivity";
          leadFormData.event_action	= "click";
          leadFormData.event_category	= "home";
          leadFormData.event_name	= "site_engagement";
          leadFormData.event = "navigate_home";
          leadFormData.event_label	= "AutoNation";
          leadFormData.event_description	= "master_home_button";
          leadFormData.event_page_location = "hero";
          leadFormData.pagegroup	= "contact";
          leadFormData.page_element	= '(not set)';
          // leadFormData.page_referral =
          leadFormData.vin= '(not set)';
          leadFormData.hyperion_id = '(not set)';
          leadFormData.make = '(not set)';
          leadFormData.make_yr = '(not set)';
          leadFormData.model = '(not set)';
          leadFormData.condition = '(not set)';
          leadFormData.login_status = '(not set)';
          leadFormData.an_user_id ='(not set)';
          leadFormData.hid = '(not set)';
          (window as any).utag_data = leadFormData;
          // this.tealium.link((window as any).utag_data);
          (window as any).utag.track('link', (window as any).utag_data);
          delete (window as any).isConfirm;
        } catch (error) {
          console.log(error);
        }
  }

  @HostListener('window:resize', ['$event'])
  onResize(_event?: Event) {
    if (window.innerWidth < 992) {
      this.isTabletView = true
    }
  }

  setupFormData() {
    console.log('setupFormData - ');
    this.preQualForm = this.fb.group({
      FirstName: [
        this.firstName, [Validators.required, Validators.minLength(2), Validators.maxLength(32), Validators.pattern(this.namePattern)]
      ],
      MI: [this.middleInitial, [
        Validators.minLength(0),
        Validators.maxLength(1),
        Validators.pattern(this.MIPattern)
      ]],
      LastName: [
        this.lastName, [Validators.required, Validators.minLength(2), Validators.maxLength(65), Validators.pattern(this.namePattern)]
      ],
      Email: [
        this.email, [Validators.required, Validators.email, Validators.pattern(this.emailPattern)]
      ],
      Phone: [
        this.phoneNumber, [Validators.minLength(14), Validators.maxLength(14), Validators.required, Validators.pattern(this.phonePattern), CustomValidator.areaCodeValidator]
      ],
      Zipcode: [
        this.zipcode,
        [Validators.required, Validators.minLength(5)]
      ],
    });

    console.log('this.preQualForm - ', this.preQualForm.getRawValue());


    setTimeout(() => {
      if (this.config.Sitecore && this.config.Sitecore.PreQualLeadInfo.zipcode) {
        this.preQualForm.get('Zipcode').updateValueAndValidity({
          emitEvent: true,
          onlySelf: true
        });
      }
    });
  }

  hasFocus(element: any) {
    return document.activeElement === element || element.isBlur;
  }

  closeJacked() {
    this.showJackedModal = false;
  }

  loadJacked() {
    this.formSubmitAttempt = true;
    this.showConfirmation = false;
    this.showJackedModal = true;
  }


  private normalizeLeadValidationValue(controlName: 'Email' | 'Phone', value: string): string {
    const normalizedValue = value || '';

    if (controlName === 'Phone') {
      return normalizedValue.replace(/\D/g, '');
    }

    return normalizedValue.trim().toLowerCase();
  }

  private createRejectedValueValidator(controlName: 'Email' | 'Phone', rejectedValue: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const currentValue = this.normalizeLeadValidationValue(controlName, control.value);
      return currentValue === rejectedValue ? { apiInvalid: true } : null;
    };
  }

  private clearRejectedValueValidator(controlName: 'Email' | 'Phone'): void {
    const control = this.preQualForm.get(controlName);
    const validator = controlName === 'Email' ? this.rejectedEmailValidator : this.rejectedPhoneValidator;

    if (control && validator) {
      control.removeValidators(validator);
      control.updateValueAndValidity({ emitEvent: false });
    }

    if (controlName === 'Email') {
      this.rejectedEmailValidator = null;
    } else {
      this.rejectedPhoneValidator = null;
    }
  }

  private applyRejectedValueValidator(controlName: 'Email' | 'Phone'): void {
    const control = this.preQualForm.get(controlName);
    if (!control) {
      return;
    }

    const rejectedValue = this.normalizeLeadValidationValue(controlName, control.value);
    this.clearRejectedValueValidator(controlName);

    if (!rejectedValue) {
      return;
    }

    const validator = this.createRejectedValueValidator(controlName, rejectedValue);
    control.addValidators(validator);
    control.updateValueAndValidity({ emitEvent: false });
    control.markAsTouched();
    control.markAsDirty();

    if (controlName === 'Email') {
      this.rejectedEmailValidator = validator;
    } else {
      this.rejectedPhoneValidator = validator;
    }
  }

  private getControlValue(controlName: string): any {
    return this.preQualForm.get(controlName)?.value;
  }

  private getPhoneDigits(): string {
    return this.normalizeLeadValidationValue('Phone', this.getControlValue('Phone'));
  }

  private buildLeadValidationRequest(): IValidateLeadRequest {
    return {
      firstName: this.getControlValue('FirstName') || '',
      lastName: this.getControlValue('LastName') || '',
      hyperionId: this.preQualLeadInfo?.HyperianId || '',
      email: this.getControlValue('Email') || '',
      phone: this.getPhoneDigits()
    };
  }

  private applyLeadValidationResult(validationResponse: IValidateLeadResponse): boolean {
    const hasHighRiskEmail = validationResponse?.Reasons?.Email?.RiskLevel === 'High';
    const hasHighRiskPhone = validationResponse?.Reasons?.Phone?.RiskLevel === 'High';
    const data = [];
    this.validationId = validationResponse?.ValidationId;
    if (hasHighRiskEmail) {
      data.push('Email');
      this.applyRejectedValueValidator('Email');
    } else {
      this.clearRejectedValueValidator('Email');
    }

    if (hasHighRiskPhone) {
      data.push('Phone');
      this.applyRejectedValueValidator('Phone');
    } else {
      this.clearRejectedValueValidator('Phone');
    }

    if (hasHighRiskEmail || hasHighRiskPhone) {
      this.formService.reportValidationContactStoreFormFailure(data.join(','));
      this.isSaving = false;
      this.cd.detectChanges();
      return false;
    }

    return true;
  }

  private async validateLeadSubmission(): Promise<boolean> {
    const validationResponse = await this.leadsvc.validateLead(
      this.buildLeadValidationRequest(),
      this.config.Sitecore?.SubPage || ''
    );

    return this.applyLeadValidationResult(validationResponse);
  }


  async submitPreQualApplication() {
    this.preQualForm.markAllAsTouched();
    this.preQualForm.markAsDirty();
    this.preQualForm.updateValueAndValidity();
    this.formSubmitAttempt = true;

    if (this.preQualForm.valid) {
      if(this.shouldValidateLead() ){
        const isLeadValidationPassed = await this.validateLeadSubmission();
        if (!isLeadValidationPassed) {
          return;
        }        
      }
      this.formService.reportContactStoreFormSubmitInitiated(this.config.Sitecore);
      const validation = { 
        enable: !this.config?.Sitecore?.CreditApplicationConfig?.PreQualificationInformation?.EnableLeadValidation ? true : false,
        id: this.validationId || null
      }
      this.createHLLead(validation);
    }
  }

  shouldValidateLead() {
    const enableLeadValidation = !!this.config?.Sitecore?.CreditApplicationConfig?.PreQualificationInformation?.EnableLeadValidation; 
    const shouldValidate = enableLeadValidation && 
          (
            ( this.config?.Sitecore?.PreQualLeadInfo?.email !== this.getControlValue('Email') ) || 
            ( this.normalizePhone(this.config?.Sitecore?.PreQualLeadInfo?.phone) !== this.normalizePhone(this.getControlValue('Phone')) )
          );

    return shouldValidate;
  }
  private normalizePhone(value: string): string {
    return (value || '').replace(/\D/g, '');
  }


  createHLLead(validation: any) {
    try {
      this.ngxService.startLoader("ContactStoreLoader");
      let params = {
        creationMode: 0,
        currentStoreHyperion: this.preQualLeadInfo.HyperianId,
        location: {
            zipCode: this.getControlValue('Zipcode')
        },
        VEHICLE:  {
           VIN:this.preQualLeadInfo.vin,
           MAKE: this.preQualLeadInfo.make,
           STOCKTYPE: this.preQualLeadInfo.inventoryType.toUpperCase() === "NEW" ? "NEW" : "USED"
        },
        source: {
           System: [this.src, this.subSrc],
           Transaction: "",
           Conditions: [""],
           ExternalSource: ""
        },
        customer: {
           name: {
              first: (this.getControlValue('FirstName') || '').replace(/'+/g, '').trim(),
              last: (this.getControlValue('LastName') || '').replace(/'+/g, '').trim()
           },
            email: this.getControlValue('Email'),
           phone: {
              text: this.getPhoneDigits(),
              phoneType: 0
           },
           customerPreference: 0
        },
        validation: validation
     }
        this.leadsvc.submitHLLead(params, this.config.Sitecore?.SubPage || '').subscribe(
        (response: any) => {
            if (response.Success) {
              this.showConfirmation = true;
              this.formService.reportContactStoreFormLeadSubmitted(this.config.Sitecore,response?.Value);
              this.formService.reportContactStoreFormSuccess(this.config.Sitecore);
              this.setupFormLoadTealium(true);
            } else {
              this.ngxService.stopLoader("ContactStoreLoader");
              this.formService.reportContactStoreFormFailure(this.config.Sitecore);
            }

          this.cd.markForCheck();
        },
        (err) => {
          console.log(err);
          this.ngxService.stopLoader("ContactStoreLoader");
          this.loadJacked();
          this.formService.reportContactStoreFormFailure(this.config.Sitecore);
          this.cd.markForCheck();
        }
      );
    } catch (error) {
      this.ngxService.stopLoader("ContactStoreLoader ");
      this.loadJacked();
      this.formService.reportContactStoreFormFailure(this.config.Sitecore);
      this.cd.markForCheck();
    }
  }





  get disableEmailFieldFn() {
    if (this.config && this.config.Sitecore && this.config.Sitecore.PreQualLeadInfo && this.config.Sitecore.PreQualLeadInfo.leadid) {
      if ((this.config.Sitecore.PreQualLeadInfo.leadid === 0 && !this.disableEmailField &&
        this.config.Sitecore.PreQualLeadInfo.email === null)) {
        return null;
      } else {
        return true;
      }
    }
  }

  stopLoader() {
    try {
      /* istanbul ignore next */
      this.ngxService.stopAllLoader('creditApplicationPreQual');
    } catch (e) {/* istanbul ignore next */
      console.error(e);
    }
  }

  async getBrowserZipcode() {
    let zipcode; 
    try {
        const location = await (window as any).AN?.locationService?.getBrowserLocation();
        if (location?.ValidPostalCode) {
          zipcode = location.PostalCode;
        }
    }
    catch(error) {
      zipcode =  (window as any).AN?.locationService?.getLocation()?.zipCode || '';
    }

    if (zipcode) {
      this.preQualForm.get('Zipcode').setValue(zipcode);
      this.cd.detectChanges();
    }
  }	
	

  updateCtas() {
    try {
      (window as any)?.standalonePrequal?.updateCtasPosition();
    } catch (error) {/* istanbul ignore next */
      console.log(error);
    }
  }

  setupFormLoadTealium(confirm?: boolean) {
    (window as any).isConfirm = confirm
    this.config.Sitecore['isConfirm']= confirm
      if(this.analyticsEventService){
      this.analyticsEventService.reportAnalyticsEvent(
        new ContactStoreComponentLoaded(this.config.Sitecore)
      );
      }
  }

  reportFormStart() {
    if(!this.isFormStarted) {
      this.formService.reportContactStoreFormStarted(this.config.Sitecore);
      this.isFormStarted = true;
    }
  }
}
